import React from "react";
import HealthCheckCTA from "./HealthCheckCTA.jsx"; // ⬅️ use the modal version

export default function InlineHealthCheckCTA() {
  return (
    <section className="max-w-6xl mx-auto my-20 px-6">
      <div className="rounded-3xl border border-blue-100 bg-gradient-to-br from-blue-50 to-white shadow-md p-8 md:p-12">
        <div className="grid md:grid-cols-3 gap-8 items-center">
          {/* Text */}
          <div className="md:col-span-2">
            <h2 className="text-2xl md:text-3xl font-bold text-blue-900">
              Free Website Health Check
            </h2>
            <p className="text-gray-700 mt-2">
              Get a quick, no-obligation audit of performance, SEO, mobile
              usability, and accessibility, with clear next steps to improve.
            </p>
            <ul className="mt-4 text-sm text-gray-700 grid sm:grid-cols-2 gap-2">
              <li>• Core Web Vitals snapshot</li>
              <li>• Mobile & accessibility issues</li>
              <li>• SEO & metadata gaps</li>
              <li>• Quick wins you can action</li>
            </ul>
          </div>

          {/* CTA → opens modal */}
          <div className="flex md:justify-end items-start">
            <HealthCheckCTA
              buttonLabel="Start My Free Health Check"
              className="!bg-orange-500 hover:!bg-orange-600"
            />
          </div>
        </div>

        <p className="text-xs text-gray-500 mt-4">
          No spam. No hard sell. Just clear insights to help you improve.
        </p>
      </div>
    </section>
  );
}
